import { Box, Button, Typography } from "@material-ui/core";
import {
  DEFAULT_ZOOM,
  MINIMUM_ZOOM_FOR_SELECTING_LOCATION,
  getDefaultLocationForUser,
} from "../../v2_actions/map";
import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core";
import { get } from "lodash";
import { useDispatch } from "react-redux";

import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import { Error } from "../layout/Error";
import { Map } from "../layout/Map";
import { getGalleriesByMonth } from "../../apis";
import { setShowMenu } from "actions/user";
import { showError } from "../../v2_actions/error";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles({
  mapContainer: {
    height: "100vh",
    minWidth: "100%",
  },
  actionButtonContainer: {},
  actionButton: {
    background: "black",
    borderRadius: 20,
    height: 40,
    marginRight: "10px",
    color: "white",
    borderRadius: "12px",
    border: "2px solid",
    fontFamily: "serif",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: "bold",
    bottom: "-400px",

    "&:hover": {
      background: "#bcc0c4",
    },
  },
  actionButton2: {
    background: "#bcc0c4",
    borderRadius: 20,
    height: 40,
    marginRight: "10px",
    color: "black",
    borderRadius: "12px",
    border: "2px solid white",
    fontFamily: "serif",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: "bold",
    bottom: "-400px",

    "&:hover": {
      background: "#bcc0c8",
    },
  },
  unset_text: {
    color: "#0c59cf",
    fontSize: "16px !important",
    fontWeight: "500",
    padding: 2,
  },
  set_text: {
    color: "white",
    fontSize: "16px !important",
    fontWeight: "500",
    padding: 2,
  },
  icon: {
    color: "black",
    width: 25,
    height: 25,
  },
  flexBtn: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between ",
    width: "300px",
    paddingLeft: "5px",
    paddingRight: "5px",
    paddingTop: "15px",
    paddingBottom: "15px",
  },
  flex1: {
    position: "absolute",
    left: "2%",
  },
  flex2: {
    position: "absolute",
    left: "15%",
    width: "75%",
    textTransform: "none",
    marginRight: "0px",
  },
});
function format(x) {
  return Number.parseFloat(x).toFixed(2);
}

const logger = {
  log: (...args) => false && console.log("LocationSelecor", ...args),
};

export const LocationSelector = ({
  formProps,
  country_code,
  currentLocation = null,
  ...props
}) => {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const [snackValue, setSnackValue] = useState({
    openSnackBar: false,
    message: "",
    type: "",
  });
  const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const [galleries, setGalleries] = useState([]);
  const [showMapSelector, setShowMapSelector] = useState(false);

  const {
    control,
    clearErrors,
    getValues,
    watch,
    setValue,
    formState: { errors },
  } = formProps;
  const required_fields = ["lat", "lng"];
  const lat = watch("lat");
  const lng = watch("lng");

  const default_location = getDefaultLocationForUser();
  const [currentZoom, setCurrentZoom] = useState(
    get(default_location, "zoom", DEFAULT_ZOOM),
  );
  const [selectedLocation, setSelectedLocation] = useState({
    lat: get(default_location, "lat", 0),
    lng: get(default_location, "lng", 0),
  });

  const isValueSet = lat && lng;

  useEffect(() => {
    dispatch(setShowMenu(false));
  }, []);

  useEffect(() => {
    const { lat, lng } = currentLocation;
    if (currentLocation && lat && lng) {
      setSelectedLocation(currentLocation);
    }
  }, [currentLocation]);

  useEffect(() => {
    let d = new Date();
    let month = d.getMonth() + 1;
    getGalleriesByMonth(month).then((res) => setGalleries(res.data));
  }, []);

  const onShowSelectLocation = () => {
    setShowMapSelector(true);
  };

  const onHideSelectLocation = () => {
    setShowMapSelector(false);
  };

  const onCancelSelectLocation = () => {
    const payload = {
      lat: lat || get(default_location, "lat"),
      lng: lng || get(default_location, "long"),
    };
    logger.log("onCancelSelectLocation", payload);
    setSelectedLocation();
    onHideSelectLocation();
  };

  const onLocationChanged = ({ lat, lng }) => {
    logger.log("onLocationChanged", { lat, lng });
    setSelectedLocation({ lat, lng });
    clearErrors();
  };

  const trySubmitLocation = () => {
    if (!get(selectedLocation, "lat") || !get(selectedLocation, "lng")) {
      showError("Please click on the map to select a location");
      return;
    }
    setValue("lat", get(selectedLocation, "lat"));
    setValue("lng", get(selectedLocation, "lng"));
    onHideSelectLocation();
  };

  const onZoomChanged = (zoom) => {
    setCurrentZoom(zoom);
  };

  const onSelectedPosition = ({ lat, lng }) => {
    logger.log("onSelectedPosition", { lat, lng });
    if (currentZoom < MINIMUM_ZOOM_FOR_SELECTING_LOCATION) {
      showError("Please increase accuracy by zooming in more");
      return;
    }
    onLocationChanged({ lat, lng });
  };

  const onSelectedPlace = (places) => {
    const place = places;
    // const {
    //   geometry: { location },
    // } = place;
    const lat = place.lat;
    const lng = place.lng;
    onLocationChanged({ lat, lng });
  };

  const renderOverlay = () => {
    return (
      <>
        {renderActionButtons()}
        {currentZoom > 15 && (
          <Typography variant="h6">
            Not zoomed in enough. The Location needs to be more accurate.
          </Typography>
        )}
      </>
    );
  };

  const renderActionButtons = () => {
    return (
      <div className={classes.actionButtonContainer}>
        <Button
          className={classes.actionButton2}
          onClick={onCancelSelectLocation}
        >
          Cancel
        </Button>
        <Button className={classes.actionButton} onClick={trySubmitLocation}>
          Submit Location
        </Button>
      </div>
    );
  };

  const renderMapSelector = () => {
    return (
      <Dialog open style={{ padding: 0, overflow: "hidden" }} maxWidth="xl">
        <DialogContent
          style={{
            width: "761px",
            height: "515px",
            overflow: "hidden",
            padding: 0,
          }}
        >
          <Map
            renderOverlay={renderActionButtons}
            initialZoom={currentZoom}
            onZoomChanged={onZoomChanged}
            onSelectPlace={onSelectedPlace}
            onSelectPosition={onSelectedPosition}
            onCancel={onCancelSelectLocation}
            setSelectedLocation={setSelectedLocation}
            pins={[selectedLocation]}
            selectLocation
            currentLocation={currentLocation}
          />
        </DialogContent>
      </Dialog>
    );
  };

  logger.log("render()", { selectedLocation, currentLocation });

  return (
    <>
      {showMapSelector && renderMapSelector()}
      <Box
        isValueSet={isValueSet}
        onClick={onShowSelectLocation}
        sx={{
          width: "98%",
          color: "#000",
          fontSize: "12px",
          cursor: "pointer",
          fontWeight: "600",
          textAlign: "left",
          top: 5,
          position: "relative",
          borderBottom: "2px solid #b9b9b9",
        }}
      >
        {isValueSet
          ? `${lat > 0 ? `${format(lat)}E` : `${format(Math.abs(lat))}W`} 
        ${lng > 0 ? `${format(lng)}N` : `${format(Math.abs(lng))}S`}
        `
          : "Select Location"}

        {(errors.lat || errors.lng) && <Error>Select a location</Error>}
      </Box>
    </>
  );
};
